import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["firstOption", "secondOption", "onChange", "value", "name", "label"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/BinarySelector/BinarySelector.js",
    _this = this;

import React from 'react';
import styled from 'styled-components';
import Radio from '../Radio';
import { noop, testIdProps } from '../../helpers';
import { withTheme } from '../../core/ThemeProvider';

var BinarySelector = function BinarySelector(props) {
  var firstOption = props.firstOption,
      secondOption = props.secondOption,
      _onChange = props.onChange,
      value = props.value,
      name = props.name,
      label = props.label,
      rest = _objectWithoutProperties(props, _excluded);

  var radioButton = function radioButton(option) {
    return /*#__PURE__*/React.createElement(RadioWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(Radio.Input, _extends({
      name: name,
      checked: option.value === value,
      onChange: function onChange(event) {
        return _onChange(event, option);
      }
    }, option, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 7
      }
    }), option.label || option.value));
  };

  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Label, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 7
    }
  }, label), /*#__PURE__*/React.createElement(RadioGroup, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, radioButton(firstOption), radioButton(secondOption)));
};

BinarySelector.defaultProps = {
  onChange: noop
};
export default BinarySelector; //#region Styles

var Wrapper = styled.div.withConfig({
  displayName: "BinarySelector__Wrapper",
  componentId: "sc-uwklhx-0"
})(["position:relative;width:auto;display:flex;flex-direction:column;justify-content:space-between;"]);
var RadioWrapper = styled.div.withConfig({
  displayName: "BinarySelector__RadioWrapper",
  componentId: "sc-uwklhx-1"
})(["display:inline-block;width:calc(50% - 4px);"]);
var RadioGroup = styled.div.withConfig({
  displayName: "BinarySelector__RadioGroup",
  componentId: "sc-uwklhx-2"
})(["label{margin:0;}"]);
var Label = withTheme(styled.div.withConfig({
  displayName: "BinarySelector__Label",
  componentId: "sc-uwklhx-3"
})(["font-family:", ";color:", ";font-size:", ";line-height:1.5;margin-bottom:", "px;@media (min-width:", "){margin:0;}"], function (_ref) {
  var _coreTheme$radioInput, _coreTheme$radioInput2;

  var coreTheme = _ref.coreTheme;
  return (_coreTheme$radioInput = coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$radioInput2 = coreTheme.radioInput) === null || _coreTheme$radioInput2 === void 0 ? void 0 : _coreTheme$radioInput2.fontFamily) !== null && _coreTheme$radioInput !== void 0 ? _coreTheme$radioInput : coreTheme.ff_sec_thin;
}, function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return coreTheme.cl_ter_l2;
}, function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return coreTheme.fs_sm;
}, function (_ref4) {
  var coreTheme = _ref4.coreTheme;
  return coreTheme.space_2;
}, function (_ref5) {
  var coreTheme = _ref5.coreTheme;
  return coreTheme.brk_xs;
})); //#endregion Styles